//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import portal from '~/net/portal'
export default {
    name: 'Newsdetail',
    data() {
        return {
            news: {}
        }
    },
    head() {
        return {
            title: this.news?.category + '-江苏技术产权交易市场',
            meta: [
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: this.news.title
                },
                {
                    hid: 'description',
                    name: 'description',
                    content: this.news.title
                }
            ]
        }
    },
    computed: {
        routes() {
            return [
                { name: '首页', path: '/' },
                { name: '资讯', path: '/news' },
                {
                    name: this.news.category,
                    path: '/news/catagory',
                    query: {
                        id: this.news.categoryId,
                        name: this.news?.category
                    }
                },
                { name: '详情' }
            ]
        }
    },
    asyncData({ params, error, req, app }) {
        return app.$api
            .getInformationById({
                id: params.id
            })
            .then(res => {
                return {
                    news: res.data
                }
            })
            .catch(e => {
                error({ statusCode: 500, messsage: '资讯不存在' })
            })
    }
}
